// eslint-disable-next-line no-restricted-imports
import {
  LegalClientsQueryVariables,
  QueryInput_LegalClientController_GetList_RiskLevels_Items as RiskLevelsApi,
  QueryInput_LegalClientController_GetList_OnboardingStatuses_Items as LegalClientOnboardingStatusTypeApi,
} from 'api/generated/graphql';
import { LegalClientsFilters } from 'api/types/data';
import {
  LegalClientOnboardingStatusType,
  OnboardingStatusType,
  RiskLevelFilterType,
} from 'api/types/entity';

type Result = Pick<
  LegalClientsQueryVariables,
  | 'search'
  | 'riskLevels'
  | 'actualCountries'
  | 'legalCountries'
  | 'onboardingStatuses'
>;

const riskLevels: Record<RiskLevelFilterType, RiskLevelsApi> = {
  [RiskLevelFilterType.Unspecified]: RiskLevelsApi.NotSpecified,
  [RiskLevelFilterType.Low]: RiskLevelsApi.Low,
  [RiskLevelFilterType.Medium]: RiskLevelsApi.Medium,
  [RiskLevelFilterType.High]: RiskLevelsApi.High,
};

const statusMap: Record<
  LegalClientOnboardingStatusType,
  LegalClientOnboardingStatusTypeApi
> = {
  [OnboardingStatusType.FillingOut]:
    LegalClientOnboardingStatusTypeApi.FillingOut,
  [OnboardingStatusType.AccountOpened]:
    LegalClientOnboardingStatusTypeApi.AccountOpened,
  [OnboardingStatusType.ComplianceCheck]:
    LegalClientOnboardingStatusTypeApi.ComplianceCheck,
  [OnboardingStatusType.AccountOpeningDenied]:
    LegalClientOnboardingStatusTypeApi.AccountOpeningDenied,
  [OnboardingStatusType.AmlCftCheck]:
    LegalClientOnboardingStatusTypeApi.AmlCftCheck,
  [OnboardingStatusType.AccountOpening]:
    LegalClientOnboardingStatusTypeApi.AccountOpening,
  [OnboardingStatusType.AwaitingAccountOpening]:
    LegalClientOnboardingStatusTypeApi.AwaitingAccountOpening,
  [OnboardingStatusType.AwaitingAmlCftCheck]:
    LegalClientOnboardingStatusTypeApi.AwaitingAmlCftCheck,
  [OnboardingStatusType.AwaitingComplianceCheck]:
    LegalClientOnboardingStatusTypeApi.AwaitingComplianceCheck,
  [OnboardingStatusType.AwaitingValidation]:
    LegalClientOnboardingStatusTypeApi.AwaitingValidation,
  [OnboardingStatusType.BoardReview]:
    LegalClientOnboardingStatusTypeApi.BoardReview,
  [OnboardingStatusType.ValidationCheck]:
    LegalClientOnboardingStatusTypeApi.ValidationCheck,
  [OnboardingStatusType.PendingBoardReview]:
    LegalClientOnboardingStatusTypeApi.PendingBoardReview,
  [OnboardingStatusType.SigningDocuments]:
    LegalClientOnboardingStatusTypeApi.SigningDocuments,
  [OnboardingStatusType.AwaitingPaymentConfirmation]:
    LegalClientOnboardingStatusTypeApi.AwaitingPaymentConfirmation,
  [OnboardingStatusType.SigningQuestionnaire]:
    LegalClientOnboardingStatusTypeApi.SigningQuestionnaire,
};

export const parseLegalClientFiltersParam = (
  filter?: LegalClientsFilters
): Result => ({
  search: filter?.search?.toString() || undefined,
  legalCountries: filter?.registrationCountries,
  actualCountries: filter?.locationCountries,
  riskLevels: filter?.riskLevels?.length
    ? filter.riskLevels.map((r) => riskLevels[r])
    : undefined,
  onboardingStatuses: filter?.statuses?.length
    ? filter.statuses.map((s) => statusMap[s])
    : undefined,
});
